import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoginResult, LoginRequest } from '../models/login';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private baseUrl = `${environment.apiUrl}/api/login`;

  constructor(private http: HttpClient) {}

  login(request: LoginRequest): Observable<LoginResult> {
  return this.http.post<LoginResult>(this.baseUrl, {
    email: request.email,
    password: request.password
  });
}

}
